export default __webpack_public_path__ + "static/media/GraphikBold.e78d3d4f.otf";